import PlanoGuard from '@/components/PlanoGuard';

const Index = () => <PlanoGuard />;

export default Index;